import { useState } from 'react';
import { trackGaEvent } from './analytics';

const COFFEE_URL = process.env.REACT_APP_DONATE_COFFEE_URL?.trim();

const CRYPTO_OPTIONS = [
  { id: 'btc', label: 'Bitcoin', address: process.env.REACT_APP_CRYPTO_BTC?.trim() },
  { id: 'eth', label: 'Ethereum', address: process.env.REACT_APP_CRYPTO_ETH?.trim() },
  { id: 'sol', label: 'Solana', address: process.env.REACT_APP_CRYPTO_SOL?.trim() },
].filter((opt) => opt.address);

export default function DonateSection() {
  const [copiedId, setCopiedId] = useState(null);
  const hasDonationOptions = Boolean(COFFEE_URL) || CRYPTO_OPTIONS.length > 0;

  async function handleCopyCrypto(option) {
    try {
      await navigator.clipboard.writeText(option.address);
      setCopiedId(option.id);
      trackGaEvent('donate_crypto_copy', { currency: option.id });
      window.setTimeout(() => setCopiedId((current) => (current === option.id ? null : current)), 2000);
    } catch {
      setCopiedId(null);
    }
  }

  return (
    <section className="donate" aria-labelledby="donate-heading">
      <p className="section-label">Still not sure?</p>
      <h2 id="donate-heading">Buy us a coffee anyway</h2>
      <p className="donate-lede">
        Still not sure if this is a real product? Enjoy it anyway? Buy us a coffee — maybe we&apos;ll send
        you a bag of trims if we have leftovers.
      </p>

      {hasDonationOptions ? (
        <div className="donate-actions">
          {COFFEE_URL ? (
            <a
              className="btn-primary donate-coffee-btn"
              href={COFFEE_URL}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackGaEvent('donate_coffee_click', { method: 'coffee' })}
            >
              ☕ Buy us a coffee
            </a>
          ) : null}

          {CRYPTO_OPTIONS.length > 0 ? (
            <div className="donate-crypto">
              <p className="donate-crypto-label">Or tip crypto (address copies to clipboard)</p>
              <div className="donate-crypto-buttons">
                {CRYPTO_OPTIONS.map((option) => (
                  <button
                    key={option.id}
                    type="button"
                    className="btn-secondary donate-crypto-btn"
                    onClick={() => handleCopyCrypto(option)}
                  >
                    {copiedId === option.id ? `${option.label} copied` : option.label}
                  </button>
                ))}
              </div>
            </div>
          ) : null}
        </div>
      ) : (
        <p className="donate-setup-note">
          We&apos;re wiring up tip links. Check back soon — or yell at Seymour.
        </p>
      )}

      <p className="fine-print donate-fine-print">
        * Leftover trims not guaranteed. May contain sock lint. Not a financial product. Definitely not
        investment advice.
      </p>
    </section>
  );
}
